import React from "react";
import {
    FileText,
    ShieldCheck,
    Bike,
    Wallet,
    Users,
    AlertTriangle
} from "lucide-react";

import "./DeliveryTerms.css";

function DeliveryTerms() {

    const terms = [

        {
            icon: <Bike size={22} />,
            title: "Safe Deliveries",
            description:
                "Always follow traffic rules and wear a helmet while delivering orders."
        },

        {
            icon: <Users size={22} />,
            title: "Customer Behaviour",
            description:
                "Treat every customer politely and professionally during pickup and delivery."
        },

        {
            icon: <Wallet size={22} />,
            title: "Payments",
            description:
                "Delivery earnings will be settled according to HomeFoods payment policy."
        },

        {
            icon: <ShieldCheck size={22} />,
            title: "Account Security",
            description:
                "Never share your login credentials or OTP with anyone."
        },

        {
            icon: <AlertTriangle size={22} />,
            title: "Policy Violations",
            description:
                "Fraudulent activities, fake deliveries, or misuse of the platform may result in permanent suspension."
        }

    ];

    return (

        <div className="delivery-terms-page">

            <div className="terms-header">

                <FileText size={40} />

                <h1>

                    Terms & Conditions

                </h1>

                <p>

                    HomeFoods Delivery Partner Agreement

                </p>

            </div>

            <div className="terms-card">

                {

                    terms.map((item, index) => (

                        <div
                            key={index}
                            className="term-item"
                        >

                            <div className="term-icon">

                                {item.icon}

                            </div>

                            <div>

                                <h3>

                                    {item.title}

                                </h3>

                                <p>

                                    {item.description}

                                </p>

                            </div>

                        </div>

                    ))

                }

            </div>

            <div className="terms-footer">

                <h3>

                    HomeFoods Version 1.0

                </h3>

                <p>

                    By using the HomeFoods platform, you agree to follow all company policies and operational guidelines. These terms may be updated from time to time.

                </p>

            </div>

        </div>

    );

}

export default DeliveryTerms;